export class ColoringCondition<T = any> {
    color: string;
    condition: (d: T) => boolean;
}